/** Where a value's weekly growth puts it. Inside ±limit is stable; the limit itself is a change. */
export type TrendDirection = 'noData' | 'stable' | 'growing' | 'decreasing';

export function describeTrend(
    value: number | null | undefined,
    growth: number | null | undefined,
    limit: number
): TrendDirection {
    if (value == null || Number.isNaN(value)) return 'noData';
    if (growth == null || Number.isNaN(growth) || Math.abs(growth) < limit) return 'stable';
    return growth > 0 ? 'growing' : 'decreasing';
}

/** The tooltip sentence for a trend; `formattedGrowth` is the growth as the page shows it. */
export function trendHelpText(
    direction: TrendDirection,
    formattedGrowth: string,
    t: (key: string) => string
): string {
    switch (direction) {
        case 'noData':
            return t('common.labels.noDataFound');
        case 'stable':
            return t('common.labels.stableText');
        case 'growing':
            return `${t('common.labels.growingBy')} ${formattedGrowth} ${t('common.labels.eachWeek')}`;
        case 'decreasing':
            return `${t('common.labels.decreasingBy')} ${formattedGrowth} ${t('common.labels.eachWeek')}`;
    }
}
